export const ACTIVE_BRANCH_COOKIE = "qerent-active-branch";

const TENANT_THEME_PATH = "/api/settings/tenant-theme";

let stylesheetRefreshCounter = 1;

// Sets (truthy) or clears (falsy) the branch cookie, which the .NET host forwards as the
// `branchName` query parameter on the tenant-theme redirect (see SettingsController).
// Path-scoped so it only accompanies the tenant-theme stylesheet request; note this makes it
// unreadable from document.cookie on app pages...
export function setActiveBranchCookie(branchName: string | null | undefined) {
    document.cookie = branchName
        ? `${ACTIVE_BRANCH_COOKIE}=${encodeURIComponent(branchName)}; path=${TENANT_THEME_PATH}; max-age=31536000; SameSite=Strict; Secure`
        : `${ACTIVE_BRANCH_COOKIE}=; path=${TENANT_THEME_PATH}; max-age=0; SameSite=Strict; Secure`;
}

// Re-requests the tenant-theme stylesheet so a branch switch applies without a full reload.
// Swap-on-load (insert new link, remove old once loaded) avoids a flash of unstyled content...
export function refreshTenantThemeStylesheet() {
    const oldLink = document.querySelector<HTMLLinkElement>(`link[rel="stylesheet"][href^="${TENANT_THEME_PATH}"]`);
    if (!oldLink) return;

    const newLink = oldLink.cloneNode() as HTMLLinkElement;

    // Cache-bust to force a refetch; the query string does not affect cookie path-matching...
    newLink.href = `${TENANT_THEME_PATH}?branchSwitch=${stylesheetRefreshCounter++}`;
    newLink.onload = newLink.onerror = () => oldLink.remove();
    oldLink.after(newLink);
}
